import { Route, Routes } from "react-router-dom";
import { AppShell } from "@/components/app-shell";
import { PoliciesList } from "@/pages/policies-list";
import { PolicyDetailPage } from "@/pages/policy-detail";
import { PolicyEditor } from "@/pages/policy-editor";
import { DomainsPage } from "@/pages/domains";
import { useTranslation } from "react-i18next";

export function App() {
  const { t } = useTranslation();
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<PoliciesList />} />
        <Route path="policies/new" element={<PolicyEditor />} />
        <Route path="policies/:id" element={<PolicyDetailPage />} />
        <Route path="policies/:id/edit" element={<PolicyEditor />} />
        <Route path="domains" element={<DomainsPage />} />
        <Route path="*" element={<p className="text-muted p-10 text-center text-sm">{t("app.notFound")}</p>} />
      </Route>
    </Routes>
  );
}
